module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/raleway-light.c47a6e71.woff";